import { useOutletContext } from 'react-router';
import type { JobTypeVersion } from '../form-config/api/client';

/** Shared context the workspace provider exposes to its child surfaces. */
export interface WorkspaceContext {
  jobTypeId: string;
  /** All versions for this job type (draft + published history). */
  versions: JobTypeVersion[];
  /** Draft store load state — Form Config uses these for its spinner +
   *  "Initialize a draft" recovery; Job Config ignores them so its non-draft
   *  REST tabs render regardless (§3.4). */
  loading: boolean;
  error: string | null;
}

export function useWorkspaceContext(): WorkspaceContext {
  return useOutletContext<WorkspaceContext>();
}
